import {
  LayoutDashboard,
  PlusCircle,
  Calendar,
  TrendingUp,
  ArrowLeft,
  QrCode,
  ScanLine,
  Landmark,
} from "lucide-react";

export const ORGANIZER_NAV_SECTIONS = [
  {
    title: "MAIN",
    items: [
      { icon: PlusCircle, label: "Create Event", href: "/create-event/form" },
      { icon: LayoutDashboard, label: "Dashboard", href: "/user/dashboard", tab: "overview" },
      { icon: Calendar, label: "My Events", href: "/user/dashboard?tab=events", tab: "events" },
      { icon: TrendingUp, label: "Sales & Revenue", href: "/user/dashboard?tab=revenue", tab: "revenue" },
      { icon: Landmark, label: "Payouts", href: "/organizer/payouts" },
    ],
  },
  {
    title: "TOOLS",
    items: [
      { icon: ScanLine, label: "Check-in", href: "/organizer/check-in" },
      { icon: QrCode, label: "SmartCodes", href: "/qr-studio" },
    ],
  },
];

export function getOrganizerActiveTab(search) {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  if (!tab || tab === "overview") return "overview";
  return tab;
}

export function isOrganizerNavActive(item, location, activeTab) {
  if (item.href === "/create-event/form") {
    return location.pathname.startsWith("/create-event");
  }
  if (item.href.startsWith("/organizer/")) {
    return location.pathname.startsWith(item.href);
  }
  if (item.href.startsWith("/qr-studio")) {
    return location.pathname.startsWith("/qr-studio");
  }
  if (location.pathname !== "/user/dashboard") {
    return false;
  }
  if (item.tab) {
    return activeTab === item.tab;
  }
  return activeTab === "overview";
}

export function getActiveOrganizerNavItem(location, activeTab) {
  for (const section of ORGANIZER_NAV_SECTIONS) {
    for (const item of section.items) {
      if (isOrganizerNavActive(item, location, activeTab)) {
        return item;
      }
    }
  }
  return ORGANIZER_NAV_SECTIONS[0].items[0];
}

export const ORGANIZER_MARKETPLACE_LINK = {
  icon: ArrowLeft,
  label: "Back to Marketplace",
  href: "/create-event",
};
